export default __webpack_public_path__ + "static/gallery15-7e6f726b5b541bbf723e700623f2bad8.png";